var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1240,
    height: 600,
    viewBox: "0 0 1240 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_6250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1171.5,
    cy: 127.5,
    r: 12.5,
    fill: "#43B97F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.5,
    cy: 553.5,
    r: 10.5,
    fill: "#4C90F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 539.5,
    r: 10.5,
    fill: "#FF6650"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.5,
    cy: 42.5,
    r: 13.5,
    fill: "#C280D2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.5,
    cy: 507.5,
    r: 10.5,
    fill: "#FFB951"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_6250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1240,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLine);
export default __webpack_public_path__ + "static/media/BackgroundLine.fc88542d79e4ec01c0d097bcda71b1c3.svg";
export { ForwardRef as ReactComponent };